import { HOST } from "../constants/HostConstants";

export const userUpdateProfile = async (user, uploadedItems, setUser) => {
  fetch(`${HOST}/api/user/userUpdatePicture`, {
    method: "POST",
    body: JSON.stringify({
      userId: user.user_id,
      uploadedItems,
    }),
    credentials: "include",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      const sanitizeUser = (userObj) => {
        if (!userObj || typeof userObj !== "object") return null;
        const { password, ssn, ...rest } = userObj;
        return rest;
      };
      setUser(sanitizeUser(data));
    });
};
